import { useQuery } from "react-query";
import { useLocation } from "react-router-dom";
import { RetailTransactionService } from "../../apis/retail_transaction";
import { ERetailTransactionSortField } from "../../core/retail_transaction/entities";
import { useQueries } from "../../helpers/QuerySearchParams";

const useFetchRetailTransactions = (date: {
  startDate: string;
  endDate: string;
}) => {
  const query = useQueries(useLocation);
  return useQuery(
    [
      "RetailTransactions",
      query.get("sort"),
      query.get("status"),
      query.get("code"),
      query.get("limit"),
      query.get("offset"),
      query.get("date"),
    ],
    () =>
      RetailTransactionService.getRetailTransactions(
        {
          offset: Number(query.get("offset")) || 0,
          limit: Number(query.get("limit")) || 10,
        },
        {
          status: query.get("status") || undefined,
          code: query.get("code") || undefined,
          date: query.get("date") || `${date.startDate},${date.endDate}`,
        },
        [
          {
            field: query.get("sort") || ERetailTransactionSortField.newest,
          },
        ]
      ),
    {
      refetchOnWindowFocus: false,
      refetchInterval: 10000,
      staleTime: 20000,
    }
  );
};

const useFetchRetailTransaction = (code: string) => {
  return useQuery(
    [`RetailTransaction-${code}`],
    () => RetailTransactionService.getRetailTransaction(code),
    {
      refetchOnWindowFocus: false,
    }
  );
};

const useFetchRetailTransactionCounter = (date: {
  startDate: string;
  endDate: string;
}) => {
  const query = useQueries(useLocation);
  return useQuery(["RetailTransactionsCounter", query.get("date")], () =>
    RetailTransactionService.getRetailTransactionCounter({
      date: query.get("date") || `${date.startDate},${date.endDate}`,
    })
  );
};

const useFetchRetailTransactionTrack = (code: string) => {
  return useQuery(
    [`RetailTransactionTrack-${code}`],
    () => RetailTransactionService.getRetailTransactionTrack(code),
    {
      refetchOnWindowFocus: false,
      refetchInterval: 10000,
      staleTime: 20000,
    }
  );
};

export {
  useFetchRetailTransactions,
  useFetchRetailTransaction,
  useFetchRetailTransactionCounter,
  useFetchRetailTransactionTrack,
};
